import { render, staticRenderFns } from "./PackagingTypesInfo.vue?vue&type=template&id=19579243&scoped=true"
import script from "./PackagingTypesInfo.vue?vue&type=script&lang=js"
export * from "./PackagingTypesInfo.vue?vue&type=script&lang=js"
import style0 from "./PackagingTypesInfo.vue?vue&type=style&index=0&id=19579243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19579243",
  null
  
)

export default component.exports